import { Outlet } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ClerkProvider } from '@clerk/react-router';
import { AuthProvider } from '@/contexts/AuthContext';
import { TenantProvider } from '@/contexts/TenantContext';
import { Toaster } from '@/components/ui/toaster';
import { KnockNotificationProvider } from '@/components/KnockNotificationProvider';
import { AnalyticsProvider } from '@/components/AnalyticsProvider';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { useState } from 'react';

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

export function RootLayout() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
            refetchOnWindowFocus: false,
          },
        },
      })
  );

  return (
    <ErrorBoundary>
      <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
        <QueryClientProvider client={queryClient}>
          <AnalyticsProvider>
            <AuthProvider>
              <TenantProvider>
                <KnockNotificationProvider>
                  <Outlet />
                  <Toaster />
                </KnockNotificationProvider>
              </TenantProvider>
            </AuthProvider>
          </AnalyticsProvider>
        </QueryClientProvider>
      </ClerkProvider>
    </ErrorBoundary>
  );
}
